import "./customer-feedback-section.scss";
import { notifyError } from "common/utils/app-monitoring/notify";

const getVideoContainers = () => document.querySelectorAll(".js-customer-feedback-video-container");
const getPlayButton = $container => $container.querySelector(".js-customer-feedback-play-button");
const getThumbnail = $container => $container.querySelector(".js-customer-feedback-thumbnail");
const getVideo = $container => $container.querySelector(".js-customer-feedback-video");
const getVideoSource = $video => $video.querySelector(".js-customer-feedback-video-source");
const getVideoUrl = $video => $video.dataset.videoUrl;

const setVideoSource = ($video, videoUrl) => {
  const $source = getVideoSource($video);
  if ($source && videoUrl) {
    $source.src = videoUrl;
    $video.load();
  }
};
const setElementVisibility = ($element, isVisible) => {
  $element.classList.toggle("hidden", !isVisible);
};

const playVideoHandle = ({ $thumbnail, $video }) => {
  const videoUrl = getVideoUrl($video);
  setVideoSource($video, videoUrl);
  setElementVisibility($thumbnail, false);
  setElementVisibility($video, true);

  $video.play().catch(error => {
    notifyError("[JS] Error playing video:", {
      params: { error: error.message }
    });
  });
};

const videoClickHandle = e => {
  const $video = e.currentTarget;
  const rect = $video.getBoundingClientRect();
  // Support both mouse and touch events
  const clientY = e.clientY ?? e.touches?.[0]?.clientY;
  if (clientY == null) return; // ignore if no coords available
  const clickY = clientY - rect.top;
  const inControlsArea = clickY >= rect.height - 50;
  if (!inControlsArea) {
    e.preventDefault();
    $video[$video.paused ? "play" : "pause"]();
  }
};

const initVideoContainer = $container => {
  const $playButton = getPlayButton($container);
  const $thumbnail = getThumbnail($container);
  const $video = getVideo($container);

  if (!$playButton || !$thumbnail || !$video) return;

  $playButton.addEventListener("click", () => playVideoHandle({ $container, $thumbnail, $video }));

  $video.addEventListener("click", videoClickHandle);
  $video.addEventListener("touchstart", videoClickHandle, { passive: false });
};

const initCustomerFeedbackVideos = () => {
  const $videoContainers = getVideoContainers();
  $videoContainers.forEach(initVideoContainer);
};

document.addEventListener("DOMContentLoaded", initCustomerFeedbackVideos);

export default initCustomerFeedbackVideos;
